import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcceptedPurchaseRequestDetailComponent } from './admin/pages/accepted-purchase-request-detail/accepted-purchase-request-detail.component';
import { ApprovalPurchaseRequestDetailComponent } from './admin/pages/approval-purchase-request-detail/approval-purchase-request-detail.component';
import { PendingPurchaseRequestDetailComponent } from './admin/pages/pending-purchase-request-detail/pending-purchase-request-detail.component';
import { PurchasingManagerComponent } from './admin/pages/purchasing-manager/purchasing-manager.component';
import { QuotationMapComponent } from './admin/pages/quotation-map/quotation-map.component';
import { purchaseAccessGuard } from './guards/purchase-access.guard';
import { purchasePendingAccessGuard } from './guards/purchase-pending-access.guard';
import { unconfirmedReviewGuard } from './guards/unconfirmed-review.guard';
import { purchaseDetailResolver } from './resolvers/purchase-detail.resolver';
import { purchaseTitleResolver } from './resolvers/purchase-title.resolver';

export const purchasingManagerRoutes: Routes = [
  {
    path: 'gerenciador-ordem-compra',
    title: 'Gestor de Compras',
    children: [
      {
        path: 'quadro',
        component: PurchasingManagerComponent,
        title: 'Solicitações de compras',
        data: {
          description: 'Acompanhe aqui as solicitações de compras realizadas pelos usuários.',
        }
      },
      {
        path: 'solicitacao-pendente/:purchaseId',
        component: PendingPurchaseRequestDetailComponent,
        title: purchaseTitleResolver,
        canActivate: [purchasePendingAccessGuard],
        canDeactivate: [unconfirmedReviewGuard],
        resolve: { purchase: purchaseDetailResolver },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          // A página tem o próprio botão de voltar e título; breadcrumb e descrição só repetiriam.
          description: '',
          breadcrumbStrategy: 'push',
          layout: { fixedHeight: true, hideBreadcrumb: true }
        }
      },
      {
        path: 'solicitacao-aceita/:purchaseId',
        component: AcceptedPurchaseRequestDetailComponent,
        title: purchaseTitleResolver,
        canActivate: [purchaseAccessGuard],
        resolve: { purchase: purchaseDetailResolver },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          // A página tem o próprio botão de voltar e título; breadcrumb e descrição só repetiriam.
          description: '',
          breadcrumbStrategy: 'push',
          layout: { fixedHeight: true, hideBreadcrumb: true }
        }
      },
      {
        path: 'mapa-de-cotacao/:purchaseId',
        component: QuotationMapComponent,
        title: purchaseTitleResolver,
        data: {
          // O mapa tem o próprio botão de voltar e título; breadcrumb e descrição só repetiriam.
          description: '',
          breadcrumbStrategy: 'push',
          layout: { fixedHeight: true, hideBreadcrumb: true }
        }
      },
      {
        path: 'aprovacao/:purchaseId',
        component: ApprovalPurchaseRequestDetailComponent,
        title: purchaseTitleResolver,
        data: {
          // A tela tem o próprio botão de voltar e título; breadcrumb e descrição só repetiriam.
          description: '',
          breadcrumbStrategy: 'push',
          layout: { hideBreadcrumb: true }
        }
      },
      {
        path: '**',
        redirectTo: 'quadro'
      }
    ]
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(purchasingManagerRoutes)],
  providers: [DatePipe]
})
export class PurchasingManagerAdminModule {}
